var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftColorIcon = function SvgGiftColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift-color-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF4452",
    d: "M16.25 4.501h-5v14.167h5c.92 0 1.666-.746 1.666-1.667V6.167c0-.92-.745-1.666-1.666-1.666M8.75 4.501h-5c-.92 0-1.666.746-1.666 1.666v10.834c0 .92.746 1.666 1.666 1.666h5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M14.73 2.165V4.5h-3.48v14.17h-2.5V4.5H5.27V2.165c0-.59.605-.995 1.15-.77L10 2.865l3.58-1.47a.835.835 0 0 1 1.15.77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift-color-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGiftColorIcon;